import { Subject } from 'rxjs'

const subject = new Subject()

export const downloadProofService = {
  emitReload: (val) => subject.next(val),
  reload: () => subject.asObservable(),
}
